import { render, staticRenderFns } from "./iflowTable.vue?vue&type=template&id=5e05316f"
import script from "./iflowTable.vue?vue&type=script&lang=js"
export * from "./iflowTable.vue?vue&type=script&lang=js"
import style0 from "./iflowTable.vue?vue&type=style&index=0&id=5e05316f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports